// Schemas used by gen2 widget JSON editors until UI editors have been created.
// Primarily used for generating example data and inputs may contain other styles as well.

import { COLOR_TYPE, FONT_FAMILY_TYPE, FONT_WEIGHT_TYPE, INTEGER_TYPE_POSITIVE } from "./schemaHelpers.js";

const PADDING = {
  type: 'object',
  additionalProperties: false,
  properties: {
    top: INTEGER_TYPE_POSITIVE,
    right: INTEGER_TYPE_POSITIVE,
    bottom: INTEGER_TYPE_POSITIVE,
    left: INTEGER_TYPE_POSITIVE
  },
  required: []
}

export const globalStyleSchema = {
  id: '/GlobalStyle',
  type: 'object',
  additionalProperties: false,
  properties: {
    chartType: {
      type: 'string',
      enum: [ // Some may be outdated, chart types pulled from docs
        'column', 'groupedColumn', 'stackedColumn',
        'normalizedColumn', 'bar', 'groupedBar',
        'stackedBar', 'normalizedBar', 'line',
        'bubble', 'pie', 'donut',
        'doughnut', 'area', 'stackedArea',
        'normalizedArea', 'histogram', 'radarLine',
        'radarArea', 'nightingale', 'radialColumn',
        'radialBar', 'sunburst', 'rangeBar',
        'rangeArea', 'boxPlot', 'treemap',
        'heatmap', 'waterfall', 'columnLineCombo',
        'areaColumnCombo', 'customCombo', 'scatter'
      ]
    },
    baseTheme: {
      type: 'string',
      enum: [
        'ag-default', 'ag-default-dark', 'ag-sheets', 'ag-sheets-dark',
        'ag-polychroma', 'ag-polychroma-dark', 'ag-vivid', 'ag-vivid-dark',
        'ag-material', 'ag-material-dark', 'ag-financial', 'ag-financial-dark'
      ]
    },
    palette: {
      type: 'object',
      additionalProperties: false,
      properties: {
        fills: {
          type: 'array',
          items: COLOR_TYPE
        },
        strokes: {
          type: 'array',
          items: COLOR_TYPE
        },
        up: {
          type: 'object',
          additionalProperties: false,
          properties: {
            fill: COLOR_TYPE,
            stroke: COLOR_TYPE
          },
          required: []
        },
        down: {
          type: 'object',
          additionalProperties: false,
          properties: {
            fill: COLOR_TYPE,
            stroke: COLOR_TYPE
          },
          required: []
        },
        neutral: {
          type: 'object',
          additionalProperties: false,
          properties: {
            fill: COLOR_TYPE,
            stroke: COLOR_TYPE
          },
          required: []
        },
      },
      required: []
    },
    params: {
      type: 'object',
      additionalProperties: false,
      properties: {
        fontFamily: FONT_FAMILY_TYPE,
        fontWeight: FONT_WEIGHT_TYPE,
        padding: INTEGER_TYPE_POSITIVE,
        accentColor: COLOR_TYPE,
        backgroundColor: COLOR_TYPE,
        borderColor: COLOR_TYPE,
        foregroundColor: COLOR_TYPE,
        fontSize: INTEGER_TYPE_POSITIVE,
        textColor: COLOR_TYPE,
        gap: INTEGER_TYPE_POSITIVE,
        borderRadius: INTEGER_TYPE_POSITIVE
      },
      required: []
    },
    overrides: {
      type: 'object',
      additionalProperties: false,
      properties: {
        common: {
          type: 'object',
          additionalProperties: false,
          properties: {
            title: {
              type: 'object',
              additionalProperties: false,
              properties: {
                enabled: { type: 'boolean' },
                text: { type: 'string' },
                color: COLOR_TYPE,
                fontSize: INTEGER_TYPE_POSITIVE,
                fontWeight: FONT_WEIGHT_TYPE,
                fontFamily: FONT_FAMILY_TYPE,
                textAlign: { type: 'string', enum: ['left', 'center', 'right'] },
                fontStyle: { type: 'string', enum: ['normal', 'italic', 'oblique'] },
                spacing: INTEGER_TYPE_POSITIVE,
                // maxWidth: INTEGER_TYPE_POSITIVE,
                maxHeight: INTEGER_TYPE_POSITIVE,
                wrapping: { type: 'string', enum: ['always', 'never', 'on-space'] }
              },
              required: []
            },
            additionalProperties: false,
            padding: PADDING
          },
          required: []
        }
      },
      required: []
    }
  }
};

export const widgetStyleSchema = {
  id: '/WidgetStyle',
  type: 'object',
  additionalProperties: false,
  properties: {
    params: globalStyleSchema.properties.params,
    overrides: globalStyleSchema.properties.overrides,
  }
};

export const chartStyleSchema = {
  id: '/ChartStyle',
  type: 'object',
  additionalProperties: false,
  properties: {
    chartType: globalStyleSchema.properties.chartType,
    baseTheme: globalStyleSchema.properties.baseTheme,
    palette: globalStyleSchema.properties.palette,
    params: globalStyleSchema.properties.params,
    overrides: {
      type: 'object',
      additionalProperties: false,
      properties: {
        common: {
          type: 'object',
          additionalProperties: false,
          properties: {
            ...globalStyleSchema.properties.overrides.properties.common.properties,
            seriesArea: {
              type: 'object',
              additionalProperties: false,
              properties: {
                padding: PADDING,
              },
            },
            zoom: {
              type: 'object',
              additionalProperties: false,
              properties: {
                enabled: { type: 'boolean' },
                enableScrolling: { type: 'boolean' },
                enablePanning: { type: 'boolean' },
                enableSelecting: { type: 'boolean' },
                enableAxisDragging: { type: 'boolean' },
                enableDoubleClickToReset: { type: 'boolean' },
                enableTwoFingerZoom: { type: 'boolean' },
                buttons: {
                  type: 'object',
                  additionalProperties: false,
                  properties: {
                    enabled: { type: 'boolean' }
                  }
                }
              }
            },
            legend: {
              type: 'object',
              additionalProperties: false,
              properties: {
                enabled: { type: 'boolean' },
                position: {
                  type: 'string', enum: ['top', 'right', 'bottom', 'left']
                },
                orientation: {
                  type: 'string', enum: ['horizontal', 'vertical']
                },
                item: {
                  type: 'object',
                  additionalProperties: false,
                  properties: {
                    label: {
                      type: 'object',
                      additionalProperties: false,
                      properties: {
                        color: COLOR_TYPE
                      }
                    }
                  }
                }
              }
            } 
          }
        }
      }
    },
  }
}